import axios from 'axios';
import {
  BulkJobb,
  JobbDetails,
  ByttAdresseCommand,
  ByttFakturaEpostCommand,
  ByttKontonummerCommand,
  FlyttEnheterTilNyHovedgrossistCommand,
  MeldEnheterInnKjedeCommand,
  FlyttEnheterTilKjedeCommand,
  FlyttEnheterTilEnhetsgruppeCommand,
  MeldEnheterUtAvEnhetsgrupperingCommand,
  MeldEnheterUtvalgInnEnhetsgrupperingCommand,
  KonsoliderKjederCommand,
  KonsoliderKjederResultat,
} from './types';

import { getKjederegAdminApiUrl } from '../../';

const baseUrl = getKjederegAdminApiUrl() + '/enheterbulk';

async function getLastJobs(): Promise<BulkJobb[]> {
  const response = await axios.get(`${baseUrl}`);
  return response.data;
}

async function getById(id: string): Promise<BulkJobb> {
  const response = await axios.get(`${baseUrl}/${id}`);
  return response.data;
}

async function getDetailsById(id: string): Promise<JobbDetails> {
  const response = await axios.get(`${baseUrl}/${id}/details`);
  return response.data;
}

async function byttAdresse(command: ByttAdresseCommand) {
  return await axios.post(`${baseUrl}/ByttAdresse`, command);
}

async function byttFakturaEpost(command: ByttFakturaEpostCommand) {
  return await axios.post(`${baseUrl}/ByttFakturaEpost`, command);
}

async function byttKontonummer(command: ByttKontonummerCommand) {
  return await axios.post(`${baseUrl}/ByttKontonummer`, command);
}

async function flyttTilNyHovedgrossist(command: FlyttEnheterTilNyHovedgrossistCommand) {
  return await axios.post(`${baseUrl}/FlyttEnheterTilNyHovedgrossist`, command);
}

async function flyttEnheterTilKjede(command: FlyttEnheterTilKjedeCommand) {
  return await axios.post(`${baseUrl}/FlyttEnheterTilKjede`, command);
}

async function flyttEnheterTilEnhetsgruppe(command: FlyttEnheterTilEnhetsgruppeCommand) {
  return await axios.post(`${baseUrl}/FlyttEnheterTilEnhetsgruppe`, command);
}

async function meldEnheterInnKjede(command: MeldEnheterInnKjedeCommand) {
  return await axios.post(`${baseUrl}/MeldEnheterInnKjede`, command);
}

async function meldEnheterUtAvEnhetsgruppering(command: MeldEnheterUtAvEnhetsgrupperingCommand) {
  return await axios.post(`${baseUrl}/MeldEnheterUtvalgUtEnhetsgruppering`, command);
}

async function meldEnheterInnIEnhetsgruppering(
  command: MeldEnheterUtvalgInnEnhetsgrupperingCommand,
) {
  return await axios.post(`${baseUrl}/MeldEnheterUtvalgInnEnhetsgruppering`, command);
}

async function konsoliderKjeder(
  command: KonsoliderKjederCommand,
): Promise<KonsoliderKjederResultat> {
  const response = await axios.post(`${baseUrl}/KonsoliderKjeder`, command);
  return response.data;
}

const EnheterBulkApi = {
  getLastJobs,
  getById,
  getDetailsById,
  byttAdresse,
  byttFakturaEpost,
  byttKontonummer,
  flyttTilNyHovedgrossist,
  meldEnheterInnKjede,
  flyttEnheterTilKjede,
  flyttEnheterTilEnhetsgruppe,
  meldEnheterUtAvEnhetsgruppering,
  meldEnheterInnIEnhetsgruppering,
  konsoliderKjeder,
};

export default EnheterBulkApi;
